import { type Relation } from '@/scripts/utils/tree';
import type { RouteItem } from '@/scripts/router/types';
import Paths from './paths';
import { genRoutes } from '@/scripts/router/utils-runtime';
import { routeMapRuntime } from './routeMap-runtime';

export const routesRelation: Relation<RouteItem> = [routeMapRuntime[Paths.MAIN]];

export const routes = genRoutes([[routeMapRuntime[Paths.BASE], routesRelation]]);
